// extracted by mini-css-extract-plugin
export var light = "styles-module--light--0f7cb";